import { StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import Table from "@/common/elements/Table";
import { useSelector } from "react-redux";
import { getFlagTableRows, getDisplayInvolvements } from "./flagUtils";

const flagMedicalDetailsHeaders = [
  { key: "flag", text: "Flag" },
  { key: "summaryDescription", text: "Summary Description" },
  { key: "relatedRecordSummary", text: "Related Record Summary" },
  { key: "expirationDate", text: "Expiration Date" },
];

const FlagMedicalDetails = () => {
  const bookings = useSelector((state) => state?.bookings?.bookings);
  const jacketFlags = useSelector((state) => state?.bookings?.jacketFlags);
  const rows = getFlagTableRows(
    getDisplayInvolvements(bookings, jacketFlags),
    "FLAGTYPES_MEDICAL",
    "Medical",
    bookings,
  );

  return (
    <>
      <StyledGridRow justify={"space-between"}>
        <StyledGridCol></StyledGridCol>
        <StyledGridCol>
          <Button>Delete</Button>
        </StyledGridCol>
      </StyledGridRow>

      <Table headers={flagMedicalDetailsHeaders} data={rows} style={{ marginTop: "15px" }} />
    </>
  );
};
export default FlagMedicalDetails;
